module.exports = __webpack_public_path__ + "static/media/cross-green-small.cb7e602c.svg";